import React from 'react';

import Card from '../../../../components/Card';

import './style.scss';

export interface NodeAnnualReportCardProps {
  title: string;
  link: string;
}

const NodeAnnualReportCard: React.FC<NodeAnnualReportCardProps> = (props) => {
  const { title, link } = props;

  return (
    <Card className="NodeAnnualReportCard">
      <Card.Content>
        <Card.Link href={link}>
          <Card.Title title={title} />
        </Card.Link>
      </Card.Content>
    </Card>
  );
};

export default NodeAnnualReportCard;
